import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { STATIC_ROOT, FAQ_ID_WHY_CASHBACK_INVALIDATED } from '../../../../constants';

import SvgComponent from '../../../SvgComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';

class CashbackHistoryLegendComponent extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <div>
                <div className="ligneForLegende">
                    {i18n.INFORMATION_MESSAGE} <strong>{i18n.NUMBER_OF_DAYS}</strong>.
                </div>
                <div className="legende flex-container-v">
                    <div className="legendeLb flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-valide.svg`}
                            width={17}
                            height={13}
                        />
                        <p>
                            <strong className="colorSpan">{i18n.VALID}</strong> :{' '}
                            {i18n.VALID_MESSAGE}
                        </p>
                    </div>
                    <div className="legendeLb legendeLbMulti flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-attente.svg`}
                            width={17}
                            height={19}
                        />
                        <p>
                            <strong className="colorSpan">{i18n.WAITING}</strong> :{' '}
                            {i18n.WAITING_MESSAGE}
                        </p>
                    </div>
                    <div className="legendeLb flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-invalide.svg`}
                            width={17}
                            height={15}
                        />
                        <p>
                            <strong className="colorSpan">{i18n.INVALID}</strong> :{' '}
                            {i18n.INVALID_MESSAGE}{' '}
                            <LocalizedNavLink
                                to={`${PATH.FAQ_PATH}${
                                    FAQ_ID_WHY_CASHBACK_INVALIDATED
                                        ? `#${FAQ_ID_WHY_CASHBACK_INVALIDATED}`
                                        : ''
                                }`}>
                                {i18n.WHY_INVALID_MESSAGE}
                            </LocalizedNavLink>
                        </p>
                    </div>
                    <div className="legendeLb flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-paye.svg`}
                            width={17}
                            height={13}
                        />
                        <p>
                            <strong className="colorSpan">{i18n.PAID}</strong> : {i18n.MESSAGE_PAYE}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(CashbackHistoryLegendComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/CashbackHistoryLegendComponent.js